import React from 'react';

import ErrorFallback from './ErrorFallback';

class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary', error, info?.componentStack);
    this.props.onError?.(error, info);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      const Fallback = this.props.FallbackComponent || ErrorFallback;

      return (
        <Fallback error={this.state.error} reset={this.reset} variant={this.props.variant} />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
